<template>
  <div>
    <BreadCrumb :data="breadCrumb" />

    <Table
      :fields="fields"
      :items="list"
      type="List"
      :loading="loading"
      :limit="limit"
      :setLimit="setLimit"
      :page="page"
      :setPage="setPage"
      :pageData="pageInfo" 
      :search="search"
      :gSearch="gSearch"
      :filtered="filtered"
      :actions="actions"
      :inputs="inputs"
      :actionEvent="actionEvent"
      :eventBtn="eventBtn"
    />
    <Modals
      :open="modalOpen"
      :modalEvent="openModal"
      :modalProps="modalProps"
      :form="currentForm"
      :modalName="modalName"
    />
  </div>
</template>

<script>
import BreadCrumb from "@/components/BreadCrumb";
import i18n from "@/plugins/i18n";
import Modals from "./modals/";
import Table from "@/components/Table";
let breadCrumb = [
  { label: i18n.t("pages.defination.name"), url: "/Defination" },
  {
    label: i18n.t("pages.defination.products"),
    url: "/Defination/Products"
  }
];
let fields = [
  { key: "name", label: i18n.t('defination.products.list.name'), keys: ["name"] },
  { key: "description", label: i18n.t('defination.products.list.description'), keys: ["description"] },
  {
    key: "active",
    label: i18n.t('defination.products.list.active'),
    keys: ["active"]
  },
  { key: "actions", label: i18n.t('defination.products.list.actions'), keys: ["actions"] }
];
let filtered = [
  "name",
  "description",
  "active",
  "actions"
];
let actions = [
  { key: "edit", text: i18n.t('general.edit') },
  { key: 'active', text: i18n.t('defination.products.list.activeAction'), state: 1 },
  { key: 'passife', text: i18n.t('defination.products.list.suspendAction'), state: 0 },
  { key: "delete", text: i18n.t('general.delete') }
];
let inputs = [
  { key: 'isActive', label: i18n.t('defination.products.inputs.state'), type: "Select", checked: false, val:"",  array:[
        {text: i18n.t('defination.products.inputs.activatedProducts'), value: true},
        {text: i18n.t('defination.products.inputs.suspendedProducts'), value: false}
  ]},
]
export default {
  name: "Products",
  async created() {
    await this.$store.dispatch('listProducts', {limit: this.limit, offset: this.offset, isActive:this.isActive})
  },
  data: function() {
    return {
      breadCrumb,
      modalOpen: false,
      modalProps: {},
      currentForm: "Products",
      modalName: "",
      fields,
      limit: 10,
      page: 1,
      offset: 0,
      isActive:true,
      dismissCountDown: 0,
      params: {
        limit: 10,
        offset: 0,
        isActive:true
      },
      filtered,
      actions,
      inputs

    };
  },

  components: {
    BreadCrumb,
    Modals,
    Table
  },
  methods: {
    search(){
        this.inputs.map((input)=>{
            input.checked ? this.params[input.key] = input.val : delete this.params[input.key] 
        })
        this.$store.dispatch('listProducts', this.params)
    },
    gSearch(data){

    },
    setLimit: function(limit) {
      this.limit = limit;
    },
    setPage: function(page) {
      if (page > 0) {
        this.page = page;
        this.offset = (page - 1) * this.limit;
      }
    },
    openModal: function(state, modal, props) {
      this.modalOpen = state;
      this.modalProps = props;
      this.modalName = modal;
    },
    actionEvent: async function(key, data) {
      switch (key) {
        case "edit":
          this.openModal(true, "edit", {...data,params:this.params});
          break;
        case "delete":
          this.openModal(true, "delete", {...data,params:this.params});
          break;
        case "add":
          this.openModal(true, "add",{params:this.params});
          break;
        case 'active':
          this.openModal(true, 'setState', {name:data.name, product: data, state:1, params:this.params})
          break;
        case 'passife': 
          this.openModal(true, 'setState', {name:data.name, product: data, state:0, params:this.params})
          break;
      }
    },

  },
  computed: {
    loading() {
        return this.$store.getters.getDefinationLoading;
    },
    list() {
        return this.$store.getters.getProducts;
    },
    pageInfo(){
        return this.$store.getters.getProductsPageInfo
    },    
    eventBtn(){
      return {
        text:i18n.t('general.add'),
        clicked:()=>{
         this.actionEvent("add");
        }
      }
    }
  },
  watch:{
    limit(val){
        this.params['limit'] = val
        this.$store.dispatch('listProducts', this.params)
    },
    offset(val){
        this.params['offset'] = val
        this.$store.dispatch('listProducts', this.params)
    }
},
};
</script>

<style lang="css" scoped>
@import "./styles/signalGroups.min.css";
</style>



// WEBPACK FOOTER //
// src/pages/General/Defination/Products.vue